import HarIdxFrame from "../../components/HarIdxFrame";

export default function ForeclosuresPage() {
  return (
    <HarIdxFrame
      eyebrow="HAR · Foreclosures"
      title="Houston foreclosure listings"
      description="Opportunity-priced foreclosure properties across the greater Houston area."
      path="mls/search"
      extraParams="for_sale=1&forcl=1"
      seoPath="/foreclosures"
    />
  );
}
